// UPLOAD
export const apiUploadFile = "/aimanager/api/v1/UploadFiles"
export const apiGetFilesByUserID = "/aimanager/api/v1/GetFiles"
export const apiDeleteFileByFileID = "/aimanager/api/v1/DeleteFileByFileID"
